import { render, staticRenderFns } from "./CardInput.vue?vue&type=template&id=2ccbed12&scoped=true&"
import script from "./CardInput.vue?vue&type=script&lang=js&"
export * from "./CardInput.vue?vue&type=script&lang=js&"
import style0 from "./CardInput.vue?vue&type=style&index=0&id=2ccbed12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbed12",
  null
  
)

export default component.exports